<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs12 sm9 v-if="!subscribeSuccess">
        <h1>{{ $t('a') }}</h1>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center mt-6>
      <v-flex xs11 sm10 v-if="!subscribeSuccess" mt-1>
        <v-layout wrap>
          <v-flex xs12>
            <pricing-selection :loadedPlans="plans" @onSelectedPlanChange="onSelectedPlanChange"/>
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="selectedPricing && user.company.dossiersLeftNb > 0 && selectedPricing.numberOfDossiersPerMonth < 10000" mt-12 justify-center>
          <v-flex xs12 sm9 pl-8>
            <v-layout wrap>
              <v-flex xs12>
                <h3>{{ $t('b1') }}</h3>
                <div>
                  <small>
                    <div>{{ $t('b2') }} {{ user.company.dossiersLeftNb }} {{ $t('b3') }}</div>
                    <div>{{ $t('b4') }}</div>
                    <div>{{ $t('b5') }} {{ user.company.dossiersLeftNb + selectedPricing.numberOfDossiersPerMonth }} {{ $t('b6') }} {{ getNewPeriodEnd().toLocaleDateString() }}{{ $t('b7') }} {{ selectedPricing.numberOfDossiersPerMonth }} {{ $t('b8') }}</div>
                  </small>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="selectedPricingId" justify-center mt-4>
          <v-flex xs12 sm9>
            <v-layout wrap mt-12 mb-6>   
              <v-flex xs12 mb-12>
                <v-card class="px-8 py-8">
                  <v-layout wrap>
                    <v-flex xs12>
                      <h2>{{ $t('j') }}</h2>
                      <div class="my-2" style="font-size:0.9em;">
                        <div>{{ $t('k') }}</div>
                        <div>
                          <span v-if="user.company.hasNoVAT">{{ $t('m') }} <b>{{ selectedAmountPerPeriod }}€</b></span>
                          <span v-else>{{ $t('m') }} <b>{{ selectedAmountPerPeriodWithVAT }}€</b> ({{ selectedAmountPerPeriod }}€ + {{ $t('n') }})</span>
                          <span v-if="!isYearlyPricingSelected"> {{ $t('n2') }} {{ currentDayNumber }} {{ $t('n3') }}</span>
                          <span v-else> {{ $t('n2yearly') }}</span>
                        </div>
                        <div class="mt-2">
                          <span v-if="!isYearlyPricingSelected" v-html="$t('r')" />
                          <span v-else v-html="$t('r2')" />
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap pt-6>
                    <v-flex xs12 v-if="isGoToStripePaymentLinkPending" text-center>
                      <v-layout wrap justify-center>
                        <v-flex xs3 mb-3>
                          <v-progress-linear indeterminate primary />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-else text-center>
                      <v-btn @click="goToStripePaymentLink" :disabled="isGoToStripePaymentLinkPending" class="secondary">{{ $t('next') }}</v-btn>
                    </v-flex>
                  </v-layout>
                  <!-- <v-layout wrap justify-center mt-6>
                    <v-flex xs12 sm6>
                      <form id="subscription-form">
                        <div id="card-element" class="stripe-card px-3 py-2">
                        </div>
                        <div id="card-errors" class="orange--text" role="alert"></div>
                      </form>
                    </v-flex>
                    <v-flex xs12 sm3 text-right :class="{'mt-6': $vuetify.breakpoint.xs}" style="margin-top: 2px">
                      <img :src="images.stripe" height="30px">
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 text-center>
                      <v-btn @click="submit" class="mt-6 secondary" :disabled="!isCardWithoutError">{{ $t('u') }}</v-btn>
                    </v-flex>
                    <v-flex xs12>
                      <span class="red--text">{{errorMessage}}</span>
                    </v-flex>
                  </v-layout> -->
                </v-card>
              </v-flex>
              <v-flex xs12 text-center>
                <div class="mt-5">
                  <img :src="images.creditCard" height="150px">
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm8 v-else text-center>
        <div class="mt-12">
          <img :src="images.success" height="300px">
        </div>
        <h3 class="secondary--text mt-12"><v-icon class="secondary--text mr-1">mdi-check</v-icon> {{ $t('v') }}</h3>
        <div class="mt-4 mb-8">{{ $t('w') }}</div>
        <v-btn to="/dossiers/create" class="mt-6 outlinedButtonWhiteBackground" outlined>
          <v-icon small class="mr-2">mdi-plus</v-icon>
          {{ $t('x') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="isCreateSubscriptionPending" width="50%" persistent>
      <v-card class="pa-6 text-center">
        <div><b>{{ $t('z') }}</b></div>
        <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import store from "@/store";
import { mapGetters } from "vuex";
// import { loadStripe } from '@stripe/stripe-js';
import { getStripePlans } from '@/helpers/subscriptions.js';
import PricingSelection from '@/components/PricingSelection'

export default {
  components: {
    PricingSelection
  },
  data: () => ({
    selectedPricing: null,
    stripeApiKey: process.env.VUE_APP_stripeApiKey,
    images: {
      stripe: require('@/assets/app/images/powered_by_stripe.png'),
      creditCard: require('@/assets/app/images/credit_card_flatline.svg'),
      entrepreneur: require('@/assets/app/images/entrepreneurs_flatline.svg'),
      success: require('@/assets/app/images/businessman__flatline.svg'),
      time: require('@/assets/app/images/time.svg'),
    },
    errorMessage: null,
    isCardWithoutError: false,
    subscribeSuccess: false,
    isCreateSubscriptionPending: false,
    isGoToStripePaymentLinkPending: false,
    plans: null
  }),
  async mounted() {
    this.plans = await getStripePlans(this.$db);
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    isYearlyPricingSelected() {
      if (!this.selectedPricing) return false
      return this.selectedPricing.isYearly
    },
    selectedPricingId() {
      if (!this.selectedPricing) return null
      return this.selectedPricing.id
    },
    currentDayNumber() {
      return new Date().getDate()
    },
    selectedAmountPerPeriodWithVAT() {
      return (this.selectedPricing.amount * 1.2).toFixed(2)
    },
    selectedAmountPerPeriod() {
      return this.selectedPricing.amount
    },
    selectedStripePriceId() {
      if (!this.selectedPricing) return null
      return process.env.VUE_APP_ENV === 'production' ? this.selectedPricing.stripePriceIdProd : this.selectedPricing.stripePriceIdDev
    }
  },
  methods: {
    onSelectedPlanChange(selectedPricing) {
      this.selectedPricing = selectedPricing
    },
    // async initStripe() {
    //   this.stripe = await loadStripe(this.stripeApiKey);
    //   this.elements = this.stripe.elements();
    //   const style = {
    //     iconStyle: 'solid',
    //     style: {
    //       base: {
    //         fontWeight: 500,
    //         fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
    //         fontSize: '16px',
    //         fontSmoothing: 'antialiased',
    //       },
    //     }
    //   }
    //   this.cardElement = this.elements.create("card", { style: style });
    //   this.cardElement.mount("#card-element");
    //   this.cardElement.addEventListener('change', this.showCardError);
    // },
    // showCardError(event) {
    //   let displayError = document.getElementById('card-errors');
    //   if (event.error) {
    //     displayError.textContent = event.error.message;
    //     this.isCardWithoutError = false
    //     this.isCreateSubscriptionPending = false
    //   } else {
    //     displayError.textContent = '';
    //     this.isCardWithoutError = event.complete
    //   }
    // },
    // displayError(errorMessage) {
    //   this.isCreateSubscriptionPending = false
    //   this.errorMessage = errorMessage
    // },
    // submit() {
    //   this.errorMessage = ''
    //   this.isCreateSubscriptionPending = true
    //   // If a previous payment was attempted, get the lastest invoice
    //   if (this.latestInvoicePaymentIntentStatus === 'requires_payment_method') {
    //     const invoiceId = this.latestInvoiceId
    //     const isPaymentRetry = true;
    //     // create new payment method & retry payment on invoice with new payment method
    //     this.createPaymentMethod({
    //       card: this.cardElement,
    //       isPaymentRetry,
    //       invoiceId,
    //     });
    //   } else {
    //     // create new payment method & create subscription
    //     this.createPaymentMethod({ card: this.cardElement });
    //   }
    // },
    // createPaymentMethod({ card, isPaymentRetry, invoiceId }) {
    //   // Set up payment method for recurring usage
    //   this.stripe.createPaymentMethod({
    //     type: 'card',
    //     card: card
    //   })
    //   .then(async (result) => {
    //     if (result.error) {
    //       this.displayError(result.error.message);
    //     } else {
    //       const priceId = this.selectedStripePriceId
    //       const customerId = (await this.$functions.httpsCallable('getOrCreateStripeCustomerId')()).data.stripeCustomerId
    //       if (isPaymentRetry) {
    //         // Update the payment method and retry invoice payment
    //         this.retryInvoiceWithNewPaymentMethod({
    //           customerId: customerId,
    //           paymentMethodId: result.paymentMethod.id,
    //           invoiceId: invoiceId,
    //           priceId: priceId,
    //         });
    //       } else {
    //         // Create the subscription
    //         this.createSubscription({
    //           customerId: customerId,
    //           paymentMethodId: result.paymentMethod.id,
    //           priceId: priceId,
    //         });
    //       }
    //     }
    //   });
    // },
    // createSubscription({ customerId, paymentMethodId, priceId }) {
    //   return this.$functions.httpsCallable('createStripeSubscription')({
    //       customerId: customerId,
    //       paymentMethodId: paymentMethodId,
    //       priceId: priceId,
    //     })
    //     .then((result) => {
    //       return {
    //         paymentMethodId: paymentMethodId,
    //         priceId: priceId,
    //         subscription: result.data,
    //       };
    //     })
    //     // Some payment methods require a customer to be on session
    //     // to complete the payment process. Check the status of the
    //     // payment intent to handle these actions.
    //     .then(this.handlePaymentThatRequiresCustomerAction)
    //     // If attaching this card to a Customer object succeeds,
    //     // but attempts to charge the customer fail, you
    //     // get a requires_payment_method error.
    //     .then(this.handleRequiresPaymentMethod)
    //     // No more actions required. Provision your service for the user.
    //     .then(this.onSubscriptionComplete)
    //     .catch((error) => {
    //       // An error has happened. Display the failure to the user here.
    //       // We utilize the HTML element we created.
    //       this.displayError(error.error.message);
    //     })
    // },
    // handlePaymentThatRequiresCustomerAction({
    //   subscription,
    //   invoice,
    //   priceId,
    //   paymentMethodId,
    //   isRetry,
    // }) {
    //   if (subscription && ['active', 'trialing'].includes(subscription.status)) {
    //     // Subscription is active, no customer actions required.
    //     return { subscription, priceId, paymentMethodId };
    //   }

    //   // If it's a first payment attempt, the payment intent is on the subscription latest invoice.
    //   // If it's a retry, the payment intent will be on the invoice itself.
    //   let paymentIntent = invoice ? invoice.payment_intent : subscription.latest_invoice.payment_intent;
    //   if (
    //     paymentIntent.status === 'requires_action' ||
    //     (isRetry === true && paymentIntent.status === 'requires_payment_method')
    //   ) {
    //     return this.stripe
    //       .confirmCardPayment(paymentIntent.client_secret, {
    //         payment_method: paymentMethodId,
    //       })
    //       .then((result) => {
    //         if (result.error) {
    //           // Start code flow to handle updating the payment details.
    //           // Display error message in your UI.
    //           // The card was declined (i.e. insufficient funds, card has expired, etc).
    //           throw result;
    //         } else {
    //           if (result.paymentIntent.status === 'succeeded') {
    //             // Show a success message to your customer.
    //             // There's a risk of the customer closing the window before the callback.
    //             // We recommend setting up webhook endpoints later in this guide.
    //             return {
    //               priceId: priceId,
    //               subscription: subscription,
    //               invoice: invoice,
    //               paymentMethodId: paymentMethodId,
    //             };
    //           }
    //         }
    //       })
    //   } else {
    //     // No customer action needed.
    //     return { subscription, priceId, paymentMethodId };
    //   }
    // },
    // handleRequiresPaymentMethod({
    //   subscription,
    //   paymentMethodId,
    //   priceId,
    // }) {
    //   if (['active', 'trialing'].includes(subscription.status)) {
    //     // subscription is active, no customer actions required.
    //     return { subscription, priceId, paymentMethodId };
    //   } else if (
    //     subscription.latest_invoice.payment_intent.status === 'requires_payment_method'
    //   ) {
    //     // Store the latest invoice ID and status.
    //     this.latestInvoiceId = subscription.latest_invoice.id;
    //     this.latestInvoicePaymentIntentStatus = subscription.latest_invoice.payment_intent.status
    //     throw { error: { message: this.$t('y') } };
    //   } else {
    //     return { subscription, priceId, paymentMethodId };
    //   }
    // },
    // retryInvoiceWithNewPaymentMethod({
    //   customerId,
    //   paymentMethodId,
    //   invoiceId,
    //   priceId
    // }) {
    //   return this.$functions.httpsCallable('stripeRetryInvoice')({
    //       customerId: customerId,
    //       paymentMethodId: paymentMethodId,
    //       invoiceId: invoiceId,
    //     })
    //     .then((result) => {
    //       return {
    //         paymentMethodId: paymentMethodId,
    //         priceId: priceId,
    //         invoice: result.data,
    //         isRetry: true,
    //       };
    //     })
    //     // Some payment methods require a customer to be on session
    //     // to complete the payment process. Check the status of the
    //     // payment intent to handle these actions.
    //     .then(this.handlePaymentThatRequiresCustomerAction)
    //     // No more actions required. Provision your service for the user.
    //     .then(this.onSubscriptionComplete)
    //     .catch((error) => {
    //       // An error has happened. Display the failure to the user here.
    //       // We utilize the HTML element we created.
    //       this.displayError(error.error.message);
    //     })
    // },
    async onSubscriptionComplete() {
      // Payment was successful.
      // await store.dispatch("updateUserData");
      this.isCreateSubscriptionPending = false
      this.subscribeSuccess = true
    },
    getNewPeriodEnd() {
      const nowDate = new Date()
      return new Date(nowDate.setMonth(nowDate.getMonth() + 1))
    },
    async goToStripePaymentLink() {
      this.isGoToStripePaymentLinkPending = true
      // Prepare a PaymentLink with these displayed information
      const session = (await this.$functions.httpsCallable('createStripeCheckoutSession')({
        priceId: this.selectedStripePriceId,
      })).data

      window.location = session.url
      
        // customerId: customerId,
        // paymentMethodId: paymentMethodId,

      //  customerId: customerId,
    //       paymentMethodId: paymentMethodId,
    //       priceId: priceId,
    }
  },
  // watch: {
  //   selectedPricingId: {
  //     handler(val, oldVal) {
  //       if (val && !oldVal) {
  //         this.initStripe()
  //       }
  //     }
  //   }
  // }
}
</script>


<style scoped>
.stripe-card {
  /* width: 300px; */
  border: 1px solid grey;
  border-radius: 10px;
}

</style> 


<i18n>
{
  "fr": {
    "a": "Choisissez un abonnement",
    "b1": "Vos dossiers gratuits restants sont conservés",
    "b2": "Il vous reste",
    "b3": "dossiers gratuits de votre période d'essai.",
    "b4": "Ils seront ajoutés à votre nouveau solde.",
    "b5": "Vous aurez donc",
    "b6": "dossiers à consommer avant le",
    "b7": ", puis",
    "b8": "dossiers consommables chaque mois.",
    "j": "Récapitulatif",
    "k": "Votre abonnement commencera aujourd'hui.",
    "m": "Vous allez être prélevés de",
    "n": "20% de TVA",
    "n2": "le",
    "n3": "de chaque mois.",
    "n2yearly": "chaque année.",
    "o": "Vous bénéficierez de",
    "p": "dossiers",
    "q": "à générer par mois.",
    "r": "Votre abonnement mensuel est <b>sans engagement</b>.<br>Vous pouvez le résilier ou changer de formule à tout instant.",
    "r2": "Vous pourrez résilier le prélèvement annuel à tout instant.",
    "s": "Il vous reste",
    "s2": "dossiers gratuits non consommés. Vous pourrez les utiliser même après avoir pris votre abonnement.",
    "u": "Valider",
    "v": "Votre abonnement a été créé avec succès.",
    "w": "Vous pouvez désormais entièrement bénéficier de nos services.",
    "x": "Créer un nouveau dossier",
    "y": "Votre carte a été refusée.",
    "z": "Merci de patienter pendant le traitement sécurisé de votre transaction.",
    "2": "Changer de formule",
    "next": "Suivant"
  },
  "en": {
    "a": "Choose your subscription",
    "b1": "Keep your unused free credits",
    "b2": "You have",
    "b3": "unused free credits left.",
    "b4": "They will be added to your new credit balance.",
    "b5": "You will thus have",
    "b6": "CVs to transform before",
    "b7": ", then",
    "b8": "transformable CVs each month.",
    "j": "Subscription details",
    "k": "Your subscription will begin today.",
    "m": "Your card will now be charged",
    "n": "20% VAT",
    "n2": "and on the ",
    "n3": "of each month.",
    "n2yearly": "each year.",
    "o": "You will be able to transform",
    "p": "CVs",
    "q": "per month.",
    "r": "You can upgrade, downgrade or cancel your subscription at any time.",
    "r2": "You can cancel your yearly billing at any time.",
    "s": "You have",
    "s2": "unused free CVs. You will still be able to use them after subscribing.",
    "u": "Subscribe",
    "v": "Your subscription was successfully created.",
    "w": "You can now fully use our services.",
    "x": "Transform a new CV",
    "y": "Your card has been refused.",
    "z": "Please wait while your transaction is being processed by our payment partner.",
    "2": "Change plan",
    "next": "Next"
  }
}
</i18n>